app.controller("EditGradeTemplateController", [
    "$scope", "GradeTemplate", "$state", "$stateParams", "$uibModal", "ConfirmModal", "toastr",
    function ($scope, GradeTemplate, $state, $stateParams, $uibModal, ConfirmModal, toastr) {
        var template = null;

        function loadTemplate() {
            GradeTemplate.one($stateParams.templateId).then(function (data) {
                template = data;
                console.log(data);
                console.log($stateParams.templateId);
                $scope.template = {name: template.name, code: template.code};

                loadTable();
            });
        }

        function loadTable() {

            var masterLayer = template.items.filter(function (e) {
                return e.parent === null;
            });

            masterLayer.map(function (el) {
                if (el.type === "group") {
                    el.items = template.items.filter(function (e) {
                        return e.parent === el._id;
                    });
                }
            });

            $scope.items = masterLayer;
        }

        loadTemplate();

        $scope.add = function (parent) {
            parent = parent || null;
            $uibModal.open({
                controller: "AddGradeComponentController",
                templateUrl: _pb + 'sudo/grade-templates/add-grade-component.html',
                size: "md",
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    params: function () {
                        return {
                            parent: parent,
                            gradeTemplate: $stateParams.templateId,
                            items: $scope.items
                            // .filter(function (el) {
                            //     return el.type !== "group";
                            // })
                        };
                    }
                }
            }).result.then(function (result) {
                loadTemplate();
            }, function () {
            });
        };

        $scope.copyTemplate = function ($event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "CopyGradeTemplateController",
                templateUrl: _pb + 'sudo/grade-templates/copy-grade-template.html',
                size: "md",
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    params: function () {
                        return {
                            gradeTemplate: template
                        };
                    }
                }
            }).result.then(function () {
                toastr.success('', "შეფასების შაბლონი წარმატებით დაკოპირდა. კოპირებული შაბლონი შეგიძლიათ იხილოთ შაბლონების სიაში.");
            });
        };

        $scope.editComponent = function (component) {
            $uibModal.open({
                controller: "EditGradeComponentController",
                templateUrl: _pb + 'sudo/grade-templates/edit-grade-component.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            component: component,
                            items: $scope.items
                            //     .filter(function (el) {
                            //     return el.type != "group";
                            // })
                        };
                    }
                }
            }).result.then(function (result) {
                loadTemplate();
            }, function () {
            });
        };

        $scope.removeComponent = function (component) {
            ConfirmModal.show({
                title: "კომპონენტის წაშლა",
                message: "გსურთ ამ კომპონენტის წაშლა?"
            }).result.then(function () {
                GradeTemplate.removeComponent(component).then(function () {
                    loadTemplate();
                });
            });
        };

        $scope.toggle = function (component) {
            GradeTemplate.toggle({gradeComponent: component._id}).then(function () {
                loadTemplate();
            });
        };

        $scope.update = function (template) {
            $state.go("");
        };

    }
]);
